import nmShopLogin from  './modules/nm-shop-login'
import nmShopCheckout from  './modules/nm-shop-checkout'
import cartSubscriptionTextSplit from './modules/cart-subscription-text-split'
import checkoutShippingRadio from './modules/checkout-shipping-radio'
import checkoutCoupons from './modules/checkout-coupons'
import checkoutDefaultPaymentMethos from './modules/checkout-default-payment-method'

//Upgrades
import upgrade11checkout from './upgrades/11-checkout'
import upgrade27checkoutFormFormat from './upgrades/27-checkout-form-format'
// import upgrade37thankYouUpsell from './upgrades/37-thank-you-upsell'
// import upgrade101thankYouSubUpsell from './upgrades/101-thank-you-sub-upsell'
import upgrade44thankYouSurvey from './upgrades/44-thank-you-survey'
// import upgrade108thankYouWarrantyUpsell from './upgrades/108-thank-you-warranty-upsell'
import upgrade111thankYouWarrantyUpsellNonsub from './upgrades/111-thank-you-warranty-upsell-nonsub'



(function($) {
	nmShopLogin.init(jQuery)
	nmShopCheckout.init(jQuery)
	cartSubscriptionTextSplit.init(jQuery)
	checkoutShippingRadio.init(jQuery)
	checkoutCoupons.init(jQuery)
	checkoutDefaultPaymentMethos.init(jQuery)

	//Upgrades
	upgrade11checkout.init(jQuery)
	upgrade27checkoutFormFormat.init(jQuery)
	upgrade27checkoutFormFormat.mobileCheckoutView(jQuery)
	// upgrade37thankYouUpsell.init(jQuery)
	upgrade44thankYouSurvey.init(jQuery)
	// upgrade101thankYouSubUpsell.init(jQuery)
	// upgrade108thankYouWarrantyUpsell.init(jQuery)
	upgrade111thankYouWarrantyUpsellNonsub.init(jQuery)

})(jQuery)